// LocContext.ADMIN
// prettier-ignore
export default {
  // localization/useLocales.tsx
  "52b9c5f4a9f0": "Fransk",
  "73fe5934011c": "Engelsk",
  "a0e76191b329": "Dansk",
  "a5bedf0afb79": "Svensk",
  "82ff82796d2f": "Norsk",
  "7954e0d2c825": "Polsk",
  "63bf2305626d": "Tysk",

  // business-components/adminSettings/AdminMenu.tsx
  "980b891859d7": "Logg ut",
  "c7585a8e7d91": "Du har adgang fordi du er på VPN",

  // business-components/adminSettings/AdminSettingsSandbox.tsx
  "68985423b0d6": "Forhåndsvisning",
  "bbb03ee2af95": "< > Kode",
  "5ed6de19d268": "Timelister",
  "8cbbc484b12f": "CV-Portal iframe",
  "45fd2e46e681": "Sett inn følgende kode i nettsiden du ønsker integrasjonen i:",
  "7d1980f62f44": "Kopier",
  "1abebec63209": "Kopiert",
  "3830371717d2": "Iframen styres av parametre i adressen til siden den befinner seg i. Hvilken side som vises er bestemt av 'cvpage' parameteren*. ",
  "eb11438bcfa3": "* Med flerside integrasjon styres iframe også av stien i adressen.",

  // business-components/adminSettings/AdminSettingsSaveChangesButton.tsx
  "eb26e23eed6d": "Lagre",

  // business-components/adminSettings/AdminSettingsStore.tsx
  "cb12499b7d9e": "Generelt",
  "16d6a8bf7e45": "Generelt",
  "40e9d4dcd165": "Integrasjon 1",
  "635ab3d433a5": "Integrasjon 1",
  "04ba57ba6fde": "Integrasjon 2",
  "346cd87f9380": "Integrasjon 2",
  "ea1d0c235d3a": "Integrasjon 3",
  "be4838976e61": "Integrasjon 3",
  "8d6ac6a41029": "Tekst og oversettelser",
  "0389537e0eec": "Tekst og oversettelser",

  // business-components/adminSettings/EmbedInPageLinks.tsx
  "c90886b0fc0d": "Sider denne integrasjonen er vist de siste 30 dagene",
  "47b4e4976940": "Vis alle",
  "b70f90c26f01": "Mer statistikk",

  // app/pages/CandidateImpersonation/index.tsx
  "764cc904d293": "Logg inn som kandidat",
  "3824a76c8145": "Kandidat ID",
  "2ee16d9342ee": "Konsern ID",
  "420066ba6420": "Logg inn",

  // app/pages/EmbedStats/index.tsx
  "cd39bf4a29de": "Embed statistikk",
  "f5b3b3c2d1c1": "Visninger",

  // app/pages/TextTest/index.tsx
  "8b7f36f8cbc0": "Test tekst 1",
  "0d86fc109ea8": "Test tekst 2",
  "eb41961da367": "Test tekst 3",
  "fa65320848ca": "Test tekst 4",
  "23ae4b407d89": "Test tekst 5",
  "a42f3ac93984": "Test tekst 6",

  // app/pages/UserOverview/index.tsx
  "1d36155e4d2a": "Brukeroversikt",
  "50646dd4c6ec": "Email",
  "b24f4234c449": "Navn",
  "28801e070cfe": "Telefon",
  "4f2f22464680": "ConcernId",
  "989f824a4cd4": "CandidateId",
  "53b5d303780b": "Guid",
  "e162e6133d87": "Operator",
  "afcb1a863a77": "Filtrer",

  // business-components/adminSettings/AdminSettingInputs/AdminSettingInputs.tsx
  "94f9c32b95e6": "Aktiver i Android og iOS app",
  "992744562503": "Aktiver den nye CV-portalen i Android og iOS appen",
  "0ad2b34b1fa0": "Ikon",
  "138872dcc89e": "Ikon for nettleseren (.ico)",
  "c2a75c7fb96c": "Logo",
  "8a7011ddc29d": "Hovedlogo (.png, .svg)",
  "0b5506bde9b3": "Velkomstbilde",
  "d32ec7f1a183": "Bilde som vises på forsiden (.png, .jpg, .jpeg, .gif)",
  "b7fa66486d12": "Standard stillingslogo",
  "8e6502d64073": "Vises i stillingslisten når stilling ikke har logo (.png, .svg)",
  "6d176fc1fc92": "Lås til nettside",
  "f5f9eceb23ed": "Nettsiden iframe skal vises i, f.eks. https://example.com. Forhindrer misbruk.",
  "db2c61eb697b": "Skrifttype",
  "957e673e4350": "Velg skrifttype (font-family)",
  "4f8a2d3d4e5a": "Stillingsliste",
  "f1b3f4e4e6b0": "Vis stillingslisten på forsiden",
  "f5e50490405b": "Login knapp",
  "d9a04c545b12": "Vis login/profil knapp over jobblisten, erstatter knappen for å endre sortering av listen",
  "5a75df73a690": "Kontaktperson portrettbilde",
  "0199ef1250c7": "Vis bilde av kontaktperson i stillingsvisningen",
  "c0cebfa60664": "Antall stillinger",
  "4541b09b18a3": "Vis antall stillinger i liste og stillingsvisningen",
  "93b14ac94d6d": "Kommune og fylke",
  "b12ea4420c2f": "Vis kommune og fylke i stillingsvisningen",
  "f3583672ed1c": "Overstyr arbeidssted",
  "ac0121fe90b2": "Overstyr \"Arbeidssted\" med verdien fra \"Avdeling/oppmøtested\" feltet",
  "9dddb291b326": "Overstyr \"Første dag\"",
  "87cd6c50483b": "Overstyr \"Første dag\" med verdien fra \"Kommentar tiltredelse\" feltet",
  "c22de2458c5b": "Krev CV i søknad",
  "1e58e18c4c5f": "Krev CV som vedlegg i søknadskjema for å kunne søke på stillinger",
  "46097243ed7a": "Krev søknadstekst i søknad",
  "a0662d926522": "Krev søknadstekst i søknadskjema for å kunne søke på stillinger",
  "d1f17b4dfa1c": "Skjul fødselsdatofelt i søknad og registrering",
  "8ecc9c12f9fa": "Sett en standard fødselsdato for kandidater",
  "4972c0ae278d": "Nasjonalitet",
  "52fdca18822d": "Vis feltet for nasjonalitet i profilen",
  "f9680e86e529": "Kunnskapsnivå",
  "0f561b017f19": "Vis feltet for nivå på kunnskap i profilen",
  "9a73e264bcbd": "Velkommen panel",
  "ef7b45934cc5": "Vis velkommen panelet på forsiden",
  "af15317c2d57": "Topbar",
  "6e57e6a2b6b6": "Vis topbaren",
  "b37eb0d47890": "Topbar",
  "70cd0c7e445c": "Vis topbaren",
  "7307c764f37f": "Sidemeny",
  "6a92f990c5d3": "Vis sidemenyen for innloggede brukere på bred skjerm",
  "70055eb7c67b": "Innlogging i gammel portal",
  "ad4515362071": "Åpne den gamle portalen ved handlinger som krever innlogging",
  "cb575229167c": "Timelister",
  "5dbba96fe5c4": "Aktiver timelister",
  "f57cfe33c1f3": "Postkasse",
  "d49e9d4cfa87": "Aktiver postkassen",
  "9477687aeb4f": "Stillinger",
  "438fe44f154e": "Aktiver stillinger",
  "9ce40122924f": "Arbeidsplan",
  "bb9e80cb427c": "Aktiver arbeidsplan",
  "2e2e26293133": "Vis kortmenyen",
  "21e07756294a": "Vis en meny som egner seg bra i iframe",
  "324687494d55": "Stoppeklokke",
  "57280f066a1d": "Aktiver stoppeklokken",
  "4ee45488fdb2": "Mest brukt",
  "8c036c32e0a7": "Menyer",
  "7dd4ddf4c158": "Forside",
  "dd232a6969c5": "Profil",
  "8852a4b9762a": "Opprett profil",
  "ae65dadd3fb9": "Timelister",
  "8be594719153": "Postkasse",
  "8fcba7419708": "Stillinger",
  "337b8b09e777": "Utseende",
  "e2e08494261f": "Stoppeklokke",

  // business-components/adminSettings/AdminSettingInputs/AdminSettingInputSearch.tsx
  "e330826a38cf": "Søk etter innstilling",

  // business-components/adminSettings/AdminSettingInputs/AsiBackgroundColorSelector.tsx
  "f52f1bfa2425": "Velg bakgrunnsfarge (background-color)",
  "ee419e74b9cb": "Bakgrunnsfarge",

  // business-components/adminSettings/AdminSettingInputs/AsiCreateProfileInputsSelector.tsx
  "b88506f811f4": "Velg skjemafelt",
  "7ebd50df7cf3": "Velg hvilke felt som skal vises i skjemaet for opprettelse av ny profil. Kandidatens navn og e-post hentes automatisk. Derfor er ikke disse feltene tilgjengelige for valg eller tilpasning her.",

  // business-components/adminSettings/AdminSettingInputs/AsiCreateProfileRequiredInputsSelector.tsx
  "0e4697c535fe": "Obligatoriske skjemafelt",
  "0fc49a4ae025": "Velg hvilke av de valgte feltene som skal være obligatoriske i skjemaet for opprettelse av ny profil.",

  // business-components/adminSettings/AdminSettingInputs/AsiDepartmentSelector.tsx
  "0884a8d6f330": "Avdelinger",
  "e4f932aaed37": "Vis kun stillinger i valgte avdelinger",

  // business-components/adminSettings/AdminSettingInputs/AsiExtraLinksInput.tsx
  "6a84f9bc941e": "Ekstra linker som vises i menyene. Om en link ikke er oppgitt for et språk viser den på engelsk. Et språk per linje i dette formatet: Språkkode|Tekst|URL",
  "0b21501b5dd2": "Ekstra linker",
  "0e822e392e47": "Ugyldig",

  // business-components/adminSettings/AdminSettingInputs/AsiFontLinkInput.tsx
  "498b4511e3ed": "Ugyldig URL",
  "0d60afd8915a": "Kun google fonts er støttet.",
  "03fda9517d77": "Font URL",
  "1d472a49d88d": "Kun google fonts er støttet (https://fonts.googleapis.com/...)",

  // business-components/adminSettings/AdminSettingInputs/AsiFontSizeSelector.tsx
  "fccd742337f5": "Skriftstørrelse",
  "9063c8dd305d": "Velg hovedskriftstørrelse (font-size)",

  // business-components/adminSettings/AdminSettingInputs/AsiGenericImagePicker.tsx
  "a5789742ea89": "Velg bilde",

  // business-components/adminSettings/AdminSettingInputs/AsiHelpers.tsx
  "95ef780bb5f7": "Arvet fra generelle innstillinger",
  "8892c788acf7": "Arvet fra generelle innstillinger",
  "589458c880db": "Verdien er arvet fra generelle instillinger taben. Finn tilsvarende innstilling under \"Generelt\" fanen for å tilbakestille til standard.",

  // business-components/adminSettings/AdminSettingInputs/AsiLanguageSelector.tsx
  "3657efd8fe00": "Språk",
  "cb48433649f4": "Velg standard språk. (Språket i forhåndsvisningen styres også av bruker og sesjon.)",

  // business-components/adminSettings/AdminSettingInputs/AsiPathBindingInput.tsx
  "4c35fc732854": "Flerside integrasjon",
  "a5508dcb5ec1": "Bruk denne for å vise iframen på flere undersider.",
  "c6f8b1f4d3a9": "Fallback",
  "f2f2b1d8b0b7": "Stillinger",
  "e2f2b1d8b0b7": "Timelister",
  "1bd84038a461": "Postkasse",
  "49638550ca64": "Flerside integrasjon",
  "52204b617633": "Lagre",

  // business-components/adminSettings/AdminSettingInputs/AsiPrimaryColorSelector.tsx
  "a49064d75566": "Hovedfarge",
  "928a9bf9c876": "Velg hovedfarge (color)",

  // business-components/adminSettings/AdminSettingInputs/AsiStartPageSelector.tsx
  "fcb1f4b5d23a": "Startside",
  "e2275d6a7e32": "Første side som vises",

  // business-components/adminSettings/AdminSettingInputs/AsiStyleSelector.tsx
  "e930d14491b5": "CSS",
  "ee65cd043876": "Ekstra CSS for å gjøre avanserte tilpasninger \n(bare Webtemp kan endre denne pt.)",

  // business-components/adminSettings/AdminSettingInputs/AsiThemeSelector.tsx
  "cef38156b723": "Theme",

  // business-components/adminSettings/AdminSettingInputs/useCreateProfileInputs.tsx
  "a8cca4117fd2": "Fornavn",
  "d046d942e979": "Etternavn",
  "fbe06801bb0d": "Telefon",
  "f8d46fbbbfd6": "Fødselsdato (skjult)",
  "1a8e73984500": "Fødselsdato",
  "0be8c8158afb": "Postnummer",
  "4e1e7d691d9f": "Nasjonalitet",
  "b251d08f37c4": "Legg til CV/Vedlegg",

  // business-components/adminSettings/Translations/AdminSettingsTranslations.tsx
  "3979f49e13c0": "Oversettelse",
  "88c7d7567769": "Oversettelser som ikke lenger er i bruk",
  "ac46252ad9da": "Oversettelser som ikke er i bruk",
  "5ded4cc64900": "Dette er oversettelser til tekster som ikke lenger finnes i systemet. Tekstene kan være fjernet eller endret.",
  "bdd19ad7f140": "Søk... (Ctrl + klikk for å fokusere)",
  "ad507a5e216b": "Lagre",
}